import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { updateAspireIntroScreenStatus, startTour } from '../../tour/Action'
import { Modal, ModalBody } from '@vmockinc/dashboard/Common/commonComps/Modal'
import { injectIntl, FormattedMessage } from 'react-intl'


class AspireUiIntro extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){
    const { updateAspireIntroScreenStatus, showAspireIntroScreen, tourstatus } = this.props
    const { detailed, summary } = tourstatus
    if(!(detailed || summary) || !showAspireIntroScreen){
      updateAspireIntroScreenStatus()
    }
  }

  hideModal() {
    const { updateAspireIntroScreenStatus } = this.props
    updateAspireIntroScreenStatus()
  }

  handleTour(){
    const { updateAspireIntroScreenStatus, startTour } = this.props
    updateAspireIntroScreenStatus()
    startTour()
  }

  render() {  
    const { showAspireIntroScreen, intl } = this.props
    return (
      <Modal
        className="aspire-intro-modal"
        isOpen={showAspireIntroScreen}
        ariaLabel={intl.formatMessage({ id: "aspireUiIntro.modal.ariaLabel", defaultMessage: "Introducing Aspire UI" })}
        onRequestHide={this.hideModal.bind(this)}
        responsive={true}
      >
        <ModalBody>
          <div className="aspire-intro-body">
            <div className="as-info-modal-close">
              <a
                href="javascript:void(0);"
                aria-label={intl.formatMessage({ id: "aspireUiIntro.close.ariaLabel", defaultMessage: "close dialog" })}
                onClick={this.hideModal.bind(this)}
                className="icon-cross as-profile-edit-close-btn modal-close-button"
              />
            </div>
            <div className="aspire-intro-img">
               <img
                src={`${process.env.APP_BASE_URL}dist/images/introImg.png`}
                alt={intl.formatMessage({ id: "aspireUiIntro.image.alt", defaultMessage: "menu btn" })}
              />
            </div>
            <div className="aspire-intro-heading">
              <FormattedMessage id="aspireUiIntro.heading" defaultMessage="Check Out Our New and Improved Look!" />
            </div>
            <div className="aspire-intro-text">
              <FormattedMessage id="aspireUiIntro.text" defaultMessage="We have refreshed the Aspire module with a sleek, modern UI! Explore the enhanced design and improved functionality now." />
            </div>
            <div className="aspire-intro-btn">
              <button
                className="btn btn-primary"
                onClick={this.handleTour.bind(this)}
              >
                <FormattedMessage id="aspireUiIntro.tourButton" defaultMessage="Take a Tour" />
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {
    showAspireIntroScreen: state.tour.showAspireIntroScreen,
    tourstatus: state.tour.tourStatus,
  }
}
export default connect(mapStateToProps, { 
  updateAspireIntroScreenStatus,
  startTour
})(
  injectIntl(AspireUiIntro)
)
